import React, { Component } from 'react';
import {
  imageBasePath,
  borderColor,
  isRtl
} from '../../library/constants';
import {
  buildImgStyleObjBasedOnOrientation,
  isMobilePhone,
  toUpper,
  doWhenReady,
  // isAndroidTablet,
} from '../../library/calc';

/*
const informUserAboutUpdatingProfilePic = ({callHookForMessageAlert}) => {

  const title = 'Notification';
  const content = 'Profile pics can only be updated by editing profile picture in Geni.';

  const type = 'info';
  const duration = 5;
  const onClose = ()=>{
    console.log('Notification is closing');
  }
  callHookForMessageAlert({title, content, type, duration, onClose});

}
*/
class Avatar extends Component {

  render(){

    const {
      nodeForFlipFocus,
      nodeObjs,
      nodeIsPresumedDeadPerson,
      nodeIsDeadPerson,
      focusNode,
      flipData,
      forwardToAddPhoto,
      translatedLabels,
      fetchIsLoading,
      activeMain,
      mainPanelIdx,
    } = this.props;

    const sideLength = 120;

    let hidePicWhenCrumbSwitching = (isMobilePhone()) && ((activeMain === 1 && mainPanelIdx === 0) || (activeMain === 0 && mainPanelIdx === 1));

    if( hidePicWhenCrumbSwitching || typeof(flipData) === 'undefined' || flipData === null || fetchIsLoading) {
      return (
        <div style={{
                width: `${sideLength}px`,
                height: `${sideLength}px`,
                position: 'relative',
                float: 'left',
                border: `1px solid ${borderColor}`,
              }}
          >
        </div>
      )
    };

    const permissions = flipData.display;

    const canAddPhoto = typeof(window.addPhoto) !== 'undefined' &&
              typeof(permissions.action_add_photo) !== 'undefined' &&
              permissions.action_add_photo;


    if(nodeForFlipFocus === null || typeof(nodeObjs[nodeForFlipFocus]) === 'undefined' ) return null;

    let deadBanner = null;
    let isDead = null;


    if(nodeIsDeadPerson({nodeObj: nodeObjs[nodeForFlipFocus], n: nodeForFlipFocus})){
      isDead = true;
      deadBanner = imageBasePath + 'deadBanner.svg';

    }

    if(nodeIsPresumedDeadPerson({nodeObj: nodeObjs[nodeForFlipFocus], n: nodeForFlipFocus})){
      isDead = true;
      deadBanner = imageBasePath + 'presummedDeadBanner.svg';
    }

    const nodeObj = nodeObjs[nodeForFlipFocus];
    const dim = 45;

    const deadBannerStyle = {
      backgroundImage: `url(${deadBanner})`,
      backgroundSize: 'contain',
      width: `${dim}px`,
      height: `${dim}px`,
      position: 'absolute',
      cursor: `${ canAddPhoto ? 'pointer': 'default'}`,
      left: `${ isMobilePhone() ? 4: 20}px`,
    };

    let uploadPhotoStyle = {
      width: `${sideLength}px`,
      height: `${sideLength}px`,
      position: 'absolute',
      cursor: `${ canAddPhoto ? 'pointer': 'default'}`,
      textAlign: 'center',
      padding: `50px 0px`,
      color: 'white',
      fontSize: '15px',
      boxSizing: 'border-box',
    };

    if( isMobilePhone()){
      uploadPhotoStyle = {...uploadPhotoStyle,
        left: '0px'
      };
    }

    if( !isMobilePhone() && isRtl ){
      uploadPhotoStyle = {...uploadPhotoStyle,
        marginRight: '208px'
      };
    }

    if( this.props.fetchIsLoading ) return (
          <div
            alt=''
            style={{
              width: `${sideLength}px`,
              height: `${sideLength}px`,
              position: 'relative',
              float: 'left',
              cursor: 'default',
              border: `1px solid gray`,
            }}>
          </div>
    );

    let placeholderImg = (this.props.fetchIsLoading ? `${imageBasePath}no_photo_${nodeObjs[nodeForFlipFocus].g}.gif` : nodeObjs[nodeForFlipFocus].img.src);
    if( typeof(nodeObj.nvp) !== 'undefined'  ) placeholderImg = `${imageBasePath}no_photo_u.gif`
    // let placeholderImg = `${imageBasePath}no_photo_${nodeObjs[nodeForFlipFocus].g}.gif`;

    if(nodeObj.img.type === 'placeholder') {

      /*
      *
      *
      *
      *
      * Placeholder
      *
      *
      *
      *
       */

      return (
        <div>
          <img
            alt=''
            style={{
              width: `${sideLength}px`,
              height: `${sideLength}px`,
              position: 'relative',
              float: 'left',
              cursor: `${ canAddPhoto ? 'pointer': 'default'}`,
              border: `2px solid ${nodeObjs[nodeForFlipFocus].photoBorderColor}`,
            }}
            src={placeholderImg}
            onClick={()=>{
              if(canAddPhoto
              ){
                if(isMobilePhone()){
                  forwardToAddPhoto()
                } else {

                    window.addPhoto(
                      nodeObjs[nodeForFlipFocus].pr_id, // highlight_pr_id -- this pr_id that we are uploading picture
                      nodeObjs[focusNode].pr_id         // focus_pr_id -- reload tree back to focus node tree
                    );

                    const whenAddPhoto = () => {
                      return document.getElementById('thin-border-lightbox') != null;
                    }

                    const callback = () => {

                      this.props.resizePhotoUploadModalForDesktopAndTablets();

                    }

                    doWhenReady({argument: '', condition: whenAddPhoto, callback, attempts: {ongoing:0, end: 99999999}, fromWhere: 'devAutoStart'})

                }
              } else{

                // informUserAboutUpdatingProfilePic({callHookForMessageAlert})

              }
            }}
          />


          {

                canAddPhoto

            ?
                <div style={uploadPhotoStyle}
                  onClick={()=>{
                    if(isMobilePhone()){
                      forwardToAddPhoto()
                    } else {

                      window.addPhoto(
                        nodeObjs[nodeForFlipFocus].pr_id, // highlight_pr_id -- this pr_id that we are uploading picture
                        nodeObjs[focusNode].pr_id         // focus_pr_id -- reload tree back to focus node tree
                      );

                      const whenAddPhoto = () => {
                        return document.getElementById('thin-border-lightbox') != null;
                      }

                      const callback = () => {

                        this.props.resizePhotoUploadModalForDesktopAndTablets();

                      }

                      doWhenReady({argument: '', condition: whenAddPhoto, callback, attempts: {ongoing:0, end: 99999999}, fromWhere: 'devAutoStart'})

                    }
                  }}
                >
                  {`${toUpper(translatedLabels['add photo'].translatedLabel)}`}
                </div>

            : null

          }



          { isDead ?
              <div style={deadBannerStyle}> </div>
            : null
          }
        </div>
      )



    } else {

        /*
        *
        *
        *   Real img uploaded by user
        *
        *
        *
        *
         */

          // this.image = new window.Image();

          // this.image.src = nodeObj.img.src;//  + '?cacheBust=' + Math.random();

          // this.image.onload = () => {

          //     console.log('loaded');

          //     if( this.image.width > this.image.height){

          //       // orientation = 'landscape';

          //     } else {

          //       // orientation = 'portrait';

          //     }


          // }

          const styleObj = buildImgStyleObjBasedOnOrientation({nodeObj});

          const borderColor = ( nodeObjs[nodeForFlipFocus].photoBorderColor === 'grey' ? 'lightgray': nodeObjs[nodeForFlipFocus].photoBorderColor);

          const style = {
            ...styleObj,
            position: 'relative',
            float: 'left',
            cursor: `${ canAddPhoto ? 'pointer': 'default'}`,
            backgroundRepeat: 'no-repeat',
            border: `2px solid ${borderColor}`,
            width: `${sideLength}px`,
            height: `${sideLength}px`,
          }

            return (
              <div>
                <div
                  alt=''
                  style={style}
                />{ isDead ?
                    <div style={deadBannerStyle}> </div>
                    : null}
              </div>
            )
        }
      };
};


export default Avatar;

/*


  const borderStyle = {
    position: 'relative',
    float: 'left',
    cursor: 'pointer',
    background: `${nodeObjs[nodeForFlipFocus].photoBorderColor}`,
    width: `${sideLength}px`,
    height: `${sideLength}px`,
    opacity: '.3',
  }

  const picStyle = {
    ...styleObj,
    position: 'absolute',
    top: '63px',
    left: '23px',
    cursor: 'pointer',
    backgroundRepeat: 'no-repeat',
    // border: `2px solid ${nodeObjs[nodeForFlipFocus].photoBorderColor}`,
    width: `${sideLength - 6 }px`,
    height: `${sideLength - 6 }px`,
  }

  return (
    <div>
      <div style={borderStyle}>
      </div>
      <div
        alt=''
        style={picStyle}
      >{ isDead ?
        <div style={deadBannerStyle}> </div>
        : null}
      </div>
    </div>
  )
 */
